const CrisisScenarioEnum = {
  Mild  : 'Mild',
  Severe: 'Severe',
  Panic : 'Panic'

}

export default CrisisScenarioEnum
